export class Lock {
  public readonly sid: string;
  public readonly cid: string;
  constructor(sid: string, cid: string) {
    this.sid = sid;
    this.cid = cid;
  }
}
